import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-b6a968a8"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "planForm"
};
var _hoisted_2 = {
  class: "box1"
};
var _hoisted_3 = {
  class: "planForm1"
};
var _hoisted_4 = {
  class: "btn"
};

var _hoisted_5 = /*#__PURE__*/_createTextVNode(" 立即提交 ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");

  var _component_el_input = _resolveComponent("el-input");

  var _component_el_form_item = _resolveComponent("el-form-item");

  var _component_UpLoadImg = _resolveComponent("UpLoadImg");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_form = _resolveComponent("el-form");

  var _directive_debounce = _resolveDirective("debounce");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Head, {
    title: "书记信箱",
    back: true
  }), _createVNode(_component_el_form, {
    ref: "ruleForms",
    model: _ctx.ruleForm,
    "label-width": "50px",
    class: "demo-ruleForm",
    rules: _ctx.rules
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form_item, {
        label: "内容",
        prop: "content"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: _ctx.content,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _ctx.content = $event;
            }),
            type: "textarea",
            autosize: {
              minRows: 6,
              maxRows: 10
            }
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      })])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_UpLoadImg, {
        ref: "uploadRef",
        limit: 9,
        onFile: _ctx.filechange
      }, null, 8, ["onFile"])]), _createElementVNode("div", _hoisted_4, [_withDirectives(_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.submitForm('ruleForms');
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_5];
        }),
        _: 1
      }, 512), [[_directive_debounce]])])];
    }),
    _: 1
  }, 8, ["model", "rules"])], 64);
}